module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "height": "0pt"
    },
    attrs: {
      "id": "_idContainer001"
    }
  }), _c('div', {
    staticClass: "basic-text-frame",
    attrs: {
      "id": "_idContainer003"
    }
  }, [_c('p', {
    staticClass: "structure-next",
    attrs: {
      "id": "calibre_pb_8"
    }
  }, [_c('span', {
    staticClass: "bold1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body_body2"
  }, [_c('span', {
    staticClass: "bold2"
  }, [_vm._v("To Gillian ")]), _c('span', {
    staticClass: "nobreak"
  }, [_c('span', {
    staticClass: "bold2"
  }, [_vm._v("and Matt, ")])]), _c('span', {
    staticClass: "bold2"
  }, [_c('br', {
    staticClass: "calibre3"
  }), _vm._v("the founders and innovators at Quot")]), _c('span', {
    staticClass: "nobreak"
  }, [_c('span', {
    staticClass: "bold2"
  }, [_vm._v("able")])]), _c('span', {
    staticClass: "nobreak"
  }, [_c('span', {
    staticClass: "bold2"
  })]), _c('span', {
    staticClass: "nobreak"
  }, [_c('span', {
    staticClass: "bold2"
  }, [_vm._v("Cards")])])]), _vm._v(" "), _c('p', {
    staticClass: "body_body2"
  }, [_vm._v("Thank you for including my words in the work you do in the world. You took your love of words and invited mine into your company’s collection with graphic beauty and immediacy. I am grateful to you for broadcasting my words around the world and letting them keep such luminous and inspirin"), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("g")]), _c('span', {
    staticClass: "nobreak"
  }), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("company.")])]), _vm._v(" "), _c('p', {
    staticClass: "pictures_picture"
  }, [_c('img', {
    staticClass: "_idgenobjectattribute1",
    attrs: {
      "alt": "",
      "src": "OEBPS/image/D77(cmyk).jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "body_body2"
  }, [_c('span', {
    staticClass: "charoverride5"
  }, [_vm._v("Design by Quotable C")]), _c('span', {
    staticClass: "nobreak1"
  }, [_vm._v("ards, Inc.")])]), _vm._v(" "), _c('p', {
    staticClass: "body_body3",
    attrs: {
      "id": "calibre_pb_9"
    }
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("*Used with permission. ")]), _c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("Shown in black ")]), _c('span', {
    staticClass: "nobreak2"
  }, [_vm._v("and")]), _c('span', {
    staticClass: "nobreak2"
  }), _c('span', {
    staticClass: "nobreak2"
  }, [_vm._v("white.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a304b02","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/LiveWithIntention_split_003.vue
// module id = 69
// module chunks = 0